import { Injectable } from '@angular/core';
import { Subject } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class EventsService {

  constructor() { }

  private sJUserLogOut = new Subject<any>();
  private sJUserLogIn = new Subject<any>();
  private sJGuest = new Subject<any>();

  nextUserPublish(topic: string, ...args: any[]) {
    // this.subject.next(topic);
    if (topic === 'logout') {
      this.sJUserLogOut.next(topic);
    } else if (topic === 'login') {
      this.sJUserLogIn.next(topic);
    } else if (topic === 'guest') {
      this.sJGuest.next(topic);
    }
  }

  nextUserGetObservable(topic: string): Subject<any> {
    if (topic === 'logout') {
      return this.sJUserLogOut;
    } else if (topic === 'login') {
      return this.sJUserLogIn;
    }  else if (topic === 'guest') {
      return this.sJGuest;
    }
  }

}
